/**
 * Dashboard period model (NAU-262). The page-level Today / This week / This
 * month selector that scopes the summary cards and Insights.
 */

export type DashboardPeriod = "today" | "this_week" | "this_month";

export const DEFAULT_PERIOD: DashboardPeriod = "this_week";

export const periodLabels: Record<DashboardPeriod, string> = {
  today: "Today",
  this_week: "This week",
  this_month: "This month",
};

/** Label for the period immediately before the selected one — used in "vs …" deltas. */
export const previousPeriodLabels: Record<DashboardPeriod, string> = {
  today: "yesterday",
  this_week: "last week",
  this_month: "last month",
};

export function isDashboardPeriod(value: unknown): value is DashboardPeriod {
  return value === "today" || value === "this_week" || value === "this_month";
}
